export default __webpack_public_path__ + "static/media/final-boss.88d01296.png";